<template>
  <div class="box" :style="{ height: `${elementHeight}px` }">
    <div class="box2">
      <div>
        <img src="../assets/image/shangjia.png" alt="" class="downloadBJ" />
        <div class="tip">
          <div class="title">首摩到家商家</div>
          <!-- <div class="gf">官方</div> -->
        </div>
      </div>
      <div class="private">
        <div class="privateTeacher" @click="downLoad()">
          <div>
            <img src="../assets/image/android.png" alt="" />
            <div>安卓版APP下载</div>
          </div>
        </div>
        <div class="privateTeacher" @click="downLoadIOS()">
          <div>
            <img src="../assets/image/ios.png" alt="" />
            <div>苹果版APP下载</div>
          </div>
          <!-- <div class="tip">苹果版暂未开放</div> -->
        </div>
      </div>
    </div>
    <download :isDown="isDown" @mongolia="downLoad"></download>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：商家下载
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2021-06-25 14:10
 */
// type : 1：banner详情  2：咨询详情  3：赛事简介   4：活动咨询详情  5：特权介绍   6：隐私政策   7：使用说明详情   8：常见问题详情   9：系统通知详情
// state 1：app 2：分享出去的
// id : 各种详情的id

// import * as wechatJS from "@/utils/wechat"; // 引入wechat.js

// import wx from "weixin-jsapi";
export default {
  data() {
    return {
      isDown: false, // 下载弹框
      isWeiXin: false,
      isAndroid: false,
      isIOS: false,
      elementHeight: 0,
    };
  },
  mounted() {
    console.log(this.$client);
    if (
      this.$client.QQ == true &&
      this.$client.QQBROWSER == true &&
      this.$client.WEIXIN != true
    ) {
      if (this.$client.ANDROID == true) {
        try {
          window.location.href = "http://ttsm.xingnuo.vip/sjd_20220531.apk";
          // setTimeout(function () {
          //   window.location.href = "http://ttsm.xingnuo.vip/sjd_20220531.apk";
          // }, 500);
          console.log("安卓");
        } catch (e) {}
      }
      if (this.$client.IPHONE == true) {
        try {
          window.location.href =
            "https://apps.apple.com/cn/app/首摩到家商家/id1629632720";
          console.log("ios");
          return;
        } catch (e) {}
      }
    }

    this.$nextTick(() => {
      console.log(this.$refs.element);
      // this.$refs.element.$el.offsetTop：元素距离浏览器顶部的高度
      this.elementHeight = window.innerHeight;

      // 监听窗口大小变化
      let context = this;
      window.onresize = () => {
        context.elementHeight = window.innerHeight;
      };
      console.log(this.elementHeight);
    });

    document.title = "下载";
  },
  methods: {
    /**
     * Created by www.xingnuocn.com
     * @title：下载app
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-06-01 13:38
     */
    downLoad() {
      console.log("下载app");
      if (
        (this.$client.QQ == true && this.$client.QQBROWSER == false) ||
        this.$client.WEIXIN == true
      ) {
        this.isDown = !this.isDown;
        return;
      } else {
        if (this.$client.ANDROID == true) {
          try {
            window.location.href = "http://ttsm.xingnuo.vip/sjd_20220531.apk";
            // setTimeout(function () {
            //   window.location.href = "http://ttsm.xingnuo.vip/sjd_20220531.apk";
            // }, 500);
            console.log("安卓");
          } catch (e) {}
        } else {
          this.$toast("请使用安卓手机下载");
        }
      }
    },

    downLoadIOS() {
      console.log("下载app");
      if (
        (this.$client.QQ == true && this.$client.QQBROWSER == false) ||
        this.$client.WEIXIN == true
      ) {
        this.isDown = !this.isDown;
        return;
      } else {
        if (this.$client.IPHONE == true) {
          try {
            window.location.href =
              "https://apps.apple.com/cn/app/首摩到家商家/id1629632720";
            console.log("ios");
            return;
          } catch (e) {}
        } else {
          this.$toast("请使用苹果手机下载");
        }
      }
    },
  },
};
</script>
<style>
.van-password-input__security {
  height: 110px;
}
.van-password-input__item {
  width: 80px;
  height: 100px;
  border: 4px solid #e2e2e2;
  border-radius: 16px;
}

.van-key {
  height: 100px;
}

.van-toast {
  width: 30%;
  height: 8% !important;
  font-size: 28px;
  line-height: 40px !important;
}
</style>
<style lang='scss' scoped>
.box {
  width: 100%;
  background: #ffffff;
  > .box2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 280px 0 0;
    height: 50%;
    .downloadBJ {
      width: 200px;
      height: 200px;
    }
    .tip {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      .title {
        display: inline-block;
        font-size: 24px;
        font-weight: bold;
        color: #222222;
        margin-right: 12px;
      }
      .gf {
        display: inline-block;
        background: #790b13;
        border-radius: 4px;
        padding: 3px 4px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        margin-top: -1px;
      }
    }

    .private {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 100px;
      .privateTeacher:nth-child(2) {
        margin-top: 60px;
      }
      .privateTeacher {
        // width: 65%;
        > div:nth-child(1) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #00c3a1;
          box-shadow: 0px 6px 12px 0px rgba(0, 195, 161, 0.3);
          border-radius: 60px;
          padding: 36px 88px;
          > img {
            width: 48px;
            height: 48px;
            margin-right: 20px;
          }
          > div {
            font-size: 32px;
            font-weight: bold;
            color: #ffffff;
          }
        }
        .tip {
          font-size: 26px;
          font-weight: 400;
          color: #ffffff;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>